module.exports = __webpack_public_path__ + "static/img/005.27c7a965.svg";